import { useState } from "react";
import { Grid, IconButton, TextField, Typography, Box, Popper, Autocomplete } from "@mui/material";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { Product } from "../../../types/types";

const CustomPopper = styled(Popper)({
  width: "600px !important", // Set your desired width here
  maxWidth: "none",
});

export type CargoItemType = Pick<
  Product,
  "SKU" | "Qty" | "StockQty" | "Name" | "NameEn" | "Barcode" | "IPName" | "Category" | "id_StockCategory"
>;

interface ItemListRowProps {
  row: CargoItemType;
  itemIndex: number;
  length: number; //used to control the visibility of DeleteIcon
  WIDTHS: any;
  onDelete: React.MouseEventHandler<HTMLElement>;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  data: Record<string, any>[];
  handleProductSelection: any;
}
const ItemListRow = (props: ItemListRowProps) => {
  const { row, itemIndex, length, WIDTHS, onDelete, onChange, data, handleProductSelection } = props;
  const productList = data as Product[];
  const [inputValue, setInputValue] = useState("");

  return (
    <>
      <Grid item sx={{ width: WIDTHS.name }}>
        <Box sx={{ width: 150, margin: "0", padding: 0 }}>
          <Autocomplete
            freeSolo
            options={productList}
            getOptionLabel={(option) => (option as Product).Name}
            PopperComponent={CustomPopper}
            filterOptions={(options, state) =>
              options.filter(
                (product) =>
                  product.SKU.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                  product.Name.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                  product.Barcode.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                  product.NameEn.toLowerCase().includes(state.inputValue.toLowerCase())
              )
            }
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            onChange={(event, newValue) => {
              handleProductSelection(newValue as Product, itemIndex);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                sx={{ width: 196 }}
                name="search"
                label="SKU,Name,Barcode"
                onChange={onChange}
              />
            )}
          />
        </Box>
      </Grid>
      <Grid item sx={{ width: WIDTHS.other }}>
        <TextField
          size="small"
          fullWidth
          inputProps={{ style: { textAlign: "center", WebkitAppearance: "none" } }}
          name="SKU"
          sx={{ backgroundColor: "lightgray" }}
          value={row.SKU}
          error={row.SKU.length === 0 ? true : false}
          // onChange={onChange}
        />
      </Grid>
      <Grid item sx={{ width: WIDTHS.qty }}>
        <TextField
          type="number"
          size="small"
          fullWidth
          inputProps={{ style: { textAlign: "center", WebkitAppearance: "none" }, min: 0, max: row.StockQty }}
          name="Qty"
          value={row.Qty}
          error={row.Qty === 0 ? true : false}
          onChange={onChange}
        />
      </Grid>
      <Grid item>
        <TextField
          size="small"
          sx={{ backgroundColor: "lightgray", width: WIDTHS.qty }}
          value={row.StockQty}
          fullWidth
        />
      </Grid>
      <Grid item>
        <TextField size="small" sx={{ backgroundColor: "lightgray", width: WIDTHS.name }} value={row.Name} fullWidth />
      </Grid>
      <Grid item>
        <TextField
          size="small"
          sx={{ backgroundColor: "lightgray", width: WIDTHS.name }}
          value={row.NameEn}
          fullWidth
        />
      </Grid>
      <Grid item>
        <TextField
          size="small"
          sx={{ backgroundColor: "lightgray", width: WIDTHS.other }}
          value={row.Barcode}
          fullWidth
        />
      </Grid>
      <Grid item>
        <TextField
          size="small"
          sx={{ backgroundColor: "lightgray", width: WIDTHS.other }}
          value={row.IPName}
          fullWidth
        />
      </Grid>
      <Grid item>
        <TextField
          size="small"
          sx={{ backgroundColor: "lightgray", width: WIDTHS.other }}
          value={row.Category}
          fullWidth
        />
      </Grid>
      <Grid item>
        <IconButton disabled={length <= 1} color="error" onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      </Grid>
      <Grid item xs={12}></Grid>
    </>
  );
};
export default ItemListRow;
